import React from "react";
import Marquee from "react-fast-marquee";

import iciciBankImg from '../Img/ICICI_Bank_Logo.svg.png';
import hdfcBankImg from '../Img/HDFC-Bank-logo.png';
import sbiBankImg from '../Img/State_Bank_of_India_logo.png';
import idfcBankImg from '../Img/Logo_of_IDFC_First_Bank.png';
import kotakBankImg from '../Img/Kotak_Mahindra_Group_logo.png';
import bankofbarodaImg from '../Img/Bank_of_Baroda_logo.png';
import axisbankImg from '../Img/Axis_Bank_logo.png';
import unionbankImg from '../Img/Union_Bank_of_India_Logo.png';
import punjabBankImg from '../Img/punjab_bank_logo.png';
import aadharHousingImg from '../Img/aadhar_housing.png';
import aavasLogoImg from '../Img/aavas-logo.png';
import adityaBirlaHousingImg from '../Img/ADITYA _BIRLA_HOUSING_FINANCE _LTD.png';
import ambitFinvestImg from '../Img/Ambit_Finvest.png';
import AnandRathiGlobalFinance from  '../Img/Anand Rathi Global Finance Limited.png';
import Arkafincap from '../Img/Arkafincap.png';
import au from '../Img/au.png';
import AVANSE from '../Img/AVANSE.png';
import axisfinance from '../Img/AXIS_FINANCE.png';
import bajajfinance from '../Img/bajaj_finance.png';
import bajajhousingfinance from '../Img/bajaj_home_finance.png';
import bandhan from '../Img/bandhan_bank.png';
import bankofindia from '../Img/bank_of_india.png';
import capitalindiahomeloans from '../Img/capital_india_home_loans.png';
import capriglobal from '../Img/capri_global_capital.png';
import centralbankofindia from '../Img/central_bank_of_india.png';
import CHOLAMANDALAMINVESTMENT from '../Img/CHOLAMANDALAM.png';
import clixcapital from '../Img/CLIX_CAPITAL.png';
import dbsbank from '../Img/DBS_BANK_LTD.png';
import dcbbank from '../Img/dcbbank.png';
import deutschebank from '../Img/deutsche_bank.png';
import easyhomefinance from '../Img/easy_home_finance.png';
import EDELWEISSRETAIL from '../Img/EDELWEISS_RETAIL_FINANCE.png';
import federalbank  from '../Img/Federal_bank_India.png';
import finnable from '../Img/finnable.png';
import gichousingfinance from '../Img/gic_housing_finance.png';
import godrejhousingfinance from '../Img/godrej_housing_finance.png';
import herohousingfinance from '../Img/herohousinfinance.png';
import hindujahousingfinance from '../Img/hinduja_housing_finance.png';
import hsbc from '../Img/hsbc.png';
import icicihomefinance from '../Img/icici_home_finance.png';
import idbibank from '../Img/IDBI_bank.png';
import ikfbank from '../Img/ikf_bank.png';
import incred from '../Img/incred.png';
import indiainfoline from '../Img/india_infoline_housing_finance.png';
import INDIABULLSHOUSING from '../Img/sammaan_capital.png';
import indianbank from '../Img/indian_bank.png';
import indifi from '../Img/indifi.png';
import indostar_home_finance from '../Img/indostar_capital_finance.png';
import induslnd_bank from '../Img/induslnd_bank.png';
import janasmallfinance from '../Img/jana_small_finance.png';
import jmfinancial from '../Img/jm_financial.png';
import CreditSaison from '../Img/credit_saison.png';
import kotakmahindraprime from '../Img/Kotak_Mahindra_prime.png';
import Krazybeeservices from '../Img/Krazybee _Services .png';
import ltfinance from '../Img/l&t finance.png';
import lendingkart from '../Img/lendingkart.png';
import loantap from '../Img/loantap.png';
import mahindrafinance from '../Img/mahindra_finance.png';
import mahindrahousingfinance from '../Img/mahindra_housing_finance.png';
import manbafinance from '../Img/manba_finance.png';
import Mangalfincorp from '../Img/Mangalfincorp.png';
import Masfinancial from '../Img/Mas _financial.png';
import MASRuralHousingandMortgageFinance from '../Img/MAS_Rural_Housing_and_Mortgage_Finance.png';
import MIRAEASSET from '../Img/mirae_asset_financial.png';
import MoneywiseFinancial from '../Img/MoneywiseFinancialServicesPrivate.png';
import MotilalOswalHomeFinance from '../Img/Motilal_Oswal_Home_Finance.png';
import MuthootFinanceHSG from '../Img/Muthoot_Finance_HSG.png';
import MuthootFinance from '../Img/muthoot_finance.png';
import MuthoothomeFin  from '../Img/muthoot_homefin.png';
import newgrowth from '../Img/neo_growth.png';
import ORIXLEASING from '../Img/ORIX_LEASING_AND_FINANCIAL.png';
import PAYSENSE from '../Img/PAYSENSE.png';
import piramalfinance from '../Img/piramal_finance.png';
import pnbhousing from '../Img/pnb_housing.png';
import poonawalla from '../Img/poonawalla_fincorp.png';
import ProfectusCapital from '../Img/Profectus_Capital.png';
import PurpleFinance from '../Img/Purple-Finance.png';
import RATNAKARBANK from '../Img/rbl_bank.png';
import SBMBank from '../Img/sbm_bank.png';
import ShinhanBank from '../Img/Shinhan_Bank.png';
import SHRIRAMCITY from '../Img/SHRIRAM_CITY.png';
import shriramfinance from '../Img/shriram_finance.png';
import truhomefinance from '../Img/truhome_finance.png';
import shubhamhousing from '../Img/shubham_housing.png';
import smfgindia from '../Img/SMFG_India.png';
import scb from '../Img/standard_chartered.png';
import SUNDARAMBNPPARIBAS from '../Img/SUNDARAM_BNP_PARIBAS.png';
import suryoday from '../Img/Suryoday.png';
import svakarma from '../Img/svakarma_finance.png';
import tatacapitalhousingfinance from '../Img/tata_capital_housing_finance.png';
import tatacapital from '../Img/tata_capital.png';
import KarurVysvaBank from '../Img/kvb.png';
import southindianbank from '../Img/south_indian_bank.png';
import UgrowCapital from '../Img/Ugrow_Capital.png';
import ujjivansmallfinance from '../Img/ujjivan_small_finance_bank.png';
import unitybank from '../Img/unity_bank.png';
import utkarshsmallfinance from '../Img/utkarsh_small_finance_bank.png';
import vastuhousingfinance from '../Img/vastu_housing_finance.png';
import vistaarfinance from '../Img/vistaar_finance.png';
import yesbank from '../Img/yes_bank.png';
import niwashousingfinance from '../Img/niwas_housing_finance.png';
import saraswatbank from '../Img/saraswat_bank.png';
import gosreefinance from '../Img/gosree_finance.png';
import pfspl from '../Img/pfspl.png';
import satinhousing from '../Img/satin_housing_finance.png';
import karanatakabank from '../Img/karanataka_bank.png';
import epimoney from '../Img/epimoney.png';
import repcohomefinance from '../Img/repco_home_finance.png';
import arthafinance from '../Img/arthan_finance.png';
import tygercapital from '../Img/tyger_capital.png';
import AeonCredit from '../Img/Aeon_Credit.png';
import jiofinance from '../Img/jio_finance.png';
import mortgagebuddy from '../Img/mortgagebuddy.png';
import svcbank from '../Img/svc_bank.png';
import mizhuo from '../Img/mizuho.png';
import dmifinance from '../Img/dmi_finance.png';

const bankLogos = [
  iciciBankImg,
  hdfcBankImg,
  sbiBankImg,
  idfcBankImg,
  kotakBankImg,
  bankofbarodaImg,
  axisbankImg,
  unionbankImg,
  punjabBankImg,
  aadharHousingImg,
  aavasLogoImg,
  adityaBirlaHousingImg,
  ambitFinvestImg,
  AnandRathiGlobalFinance,
  Arkafincap,
  au,
  AVANSE,
  axisfinance,
  bajajfinance,
  bajajhousingfinance,
  bandhan,
  bankofindia,
  capitalindiahomeloans,
  capriglobal,
  centralbankofindia,
  CHOLAMANDALAMINVESTMENT,
  clixcapital,
  dbsbank,
  dcbbank,
  deutschebank,
  easyhomefinance,
  EDELWEISSRETAIL,
  federalbank,
  finnable,
  gichousingfinance,
  godrejhousingfinance,
  herohousingfinance,
  hindujahousingfinance,
  hsbc,
  icicihomefinance,
  idbibank,
  ikfbank,
  incred,
  indiainfoline,
  INDIABULLSHOUSING,
  indianbank,
  indifi,
  indostar_home_finance,
  induslnd_bank,
  janasmallfinance,
  jmfinancial,
  CreditSaison,
  kotakmahindraprime,
  Krazybeeservices,
  ltfinance,
  lendingkart,
  loantap,
  mahindrafinance,
  mahindrahousingfinance,
  manbafinance,
  Mangalfincorp,
  Masfinancial,
  MASRuralHousingandMortgageFinance,
  MIRAEASSET,
  MoneywiseFinancial,
  MotilalOswalHomeFinance,
  MuthootFinanceHSG,
  MuthootFinance,
  MuthoothomeFin,
  newgrowth,
  ORIXLEASING,
  PAYSENSE,
  piramalfinance,
  pnbhousing,
  poonawalla,
  ProfectusCapital,
  PurpleFinance,
  RATNAKARBANK,
  SBMBank,
  ShinhanBank,
  SHRIRAMCITY,
  shriramfinance,
  truhomefinance,
  shubhamhousing,
  smfgindia,
  scb,
  SUNDARAMBNPPARIBAS,
  suryoday,
  svakarma,
  tatacapitalhousingfinance,
  tatacapital,
  KarurVysvaBank,
  southindianbank,
  UgrowCapital,
  ujjivansmallfinance,
  unitybank,
  utkarshsmallfinance,
  vastuhousingfinance,
  vistaarfinance,
  yesbank,
  niwashousingfinance,
  saraswatbank,
  gosreefinance,
  pfspl,
  satinhousing,
  karanatakabank,
  repcohomefinance,
  arthafinance,
  tygercapital,
  AeonCredit,
  jiofinance,
  mortgagebuddy,
  svcbank,
  mizhuo,
  dmifinance,
];

const Associates = () => {
  return (
    <div className="loan-card-main" style={{ overflowX: "hidden", maxWidth: "89%", margin: "0 auto" }}>
      <h2 className="sections-title-smco">
        <span className="horizontal-line"></span>We Are Associated With
      </h2>

      <p className="sections-description-smco">
        We are associated with all major private, government banks, and NBFCs. Below are a few of the banks we work with to provide you the best loan options:
      </p>

      {/* Wrapper to limit width and prevent overflow */}
      <div style={{ overflowX: "hidden", maxWidth: "100%", margin: "0 auto" }}>
        <Marquee
          gradient={false}
          speed={40}
          pauseOnHover={true}
          className="bank-marquee"
        >
          {bankLogos.map((src, idx) => (
            <div key={idx} style={{ margin: "0 2rem", flexShrink: 0 }}>
              <img
                src={src}
                alt={`bank-${idx}`}
                style={{
                  maxWidth: "150px",
                  maxHeight: "60px",
                  objectFit: "contain",
                  transition: "filter 0.3s ease",
                }}
                onMouseOver={e => (e.currentTarget.style.filter = "none")}
                onMouseOut={e => (e.currentTarget.style.filter = "grayscale(100%)")}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Associates;
